/**
 * Created by wuhao on 2017/4/7.
 */
import { Mutations } from '@/store/mutations';
import { getToken } from '@/utils/auth';
import Stomp, { Client, Message } from 'stompjs';
import Vue, { VueConstructor } from 'vue';
import { api } from '@/plugins/api';
import store from '../store';
localStorage.setItem('isReady','0');
let stomp: Client | null = null;
const subscribes: Array<{
  topic: string;
  callback: (data: any, message: Message) => void;
}> = [];
let timer: any = null;

function clear() {
  if (timer) {
    clearInterval(timer);
  }
}

export const connect = (init = false) => {
  // 先断开上一次 stomp实例
  if (stomp) {
    stomp.disconnect(() => {
      // subscribes.forEach()
    });
  }

  const schema = location.protocol === 'http:' ? 'ws' : 'wss';
  const url =    `${schema}://${location.host}/api/websocket?access_token=` + getToken();

  // 创建 ws 并over接管，返回 stomp 实例
  const socket = new WebSocket(url);
  stomp = Stomp.over(socket);

  // debug
  stomp.debug = msg => {
    console.log('websocket:' + msg);
  };

  // 监听 message 信息，在console中有体现
  stomp.ws.addEventListener('message', m => {
    if (typeof m.data === 'string' && m.data.indexOf('CONNECTED') === 0) {
      console.log(
        '%c websocket connected',
        'background-color: darkgreen;color: white'
      );
    }
  });
  stomp.ws.addEventListener('close', () => {
    store.commit(Mutations.WEBSOCKET_STATE, 'disconnected');
    console.log(
      '%c websocket disconnect',
      'background-color: #2a84de;color: white'
    );
    clear();
    timer = setInterval(() => {
      connect(true);
      if (localStorage.getItem('isReady') === '1') {
        console.log('重置为就绪');
        api.video.trtc.ready.r().then((res:any)=> {
          if (res.code === '200') {
            store.commit(Mutations.CHANGE_READY_STATE); // 修改就绪样式
            localStorage.setItem('isReady','1');
          }
        }); // 就绪请求
      }
    }, 2000);
  });

  store.commit(Mutations.WEBSOCKET_STATE, 'connecting');
  // log 正在连接
  console.log(
    '%c websocket connecting',
    'background-color: #2a84de;color: white'
  );

  // 主动发送 connect 和小程序创建ws思路一致：先 connect 再 subscribe
  stomp.connect({ Authorization: 'bearer ' + getToken() }, frame => {
    store.commit(Mutations.WEBSOCKET_STATE, 'connected');
    clear();
    if (init) {
      subscribes.forEach(item => {
        stomp!.subscribe(item.topic, message => {
          if (message.body) {
            item.callback(JSON.parse(message.body), message);
          }
        });
      });
    }
  });
};

export const subscribe = <T>(
  topic: string,
  callback: (data: T, message?: Message) => void
) => {
  if (stomp!.connected) {
    stomp!.subscribe(topic, message => {
      if (message.body) {
        callback(JSON.parse(message.body), message);
      }
    });
  }
  subscribes.push({ topic, callback });
};

const plugin = {
  installed: false,
  install(vue: VueConstructor) {
    if (plugin.installed) {
      return;
    }
    vue.prototype.$subscribe = (
      topic: string,
      callback: (message: Message) => {}
    ) => {
      return new Promise((resolve, reject) => {
        if (stomp!.connected) {
          resolve(stomp!.subscribe(topic, callback));
        } else {
          subscribes.push({ topic, callback });
        }
      });
    };
    vue.prototype.$unsubscribe = (id: string) => {
      if (stomp!.connected) {
        stomp!.unsubscribe(id);
      }
    };
    Object.defineProperties(vue.prototype, {
      $stomp: {
        get() {
          return stomp;
        }
      }
    });
  }
};
Vue.use(plugin);
